// Generated from the Upzi DLS Figma icon library by sync-dls-icons.mjs.
import { createDlsIcon } from './dls-icon';

const MoreIcon = createDlsIcon('MoreIcon', {
  filled: (
    <>
      <path
        d="M7.99805 18.498C4.97719 18.498 2.49609 20.9791 2.49609 24C2.49609 27.0209 4.97719 29.502 7.99805 29.502C11.0183 29.502 13.5 27.0209 13.5 24C13.5 20.9791 11.0183 18.498 7.99805 18.498ZM39.998 18.498C36.9772 18.498 34.4961 20.9791 34.4961 24C34.4961 27.0209 36.9772 29.502 39.998 29.502C43.0183 29.502 45.5 27.0209 45.5 24C45.5 20.9791 43.0183 18.498 39.998 18.498ZM23.998 18.5C20.9776 18.5 18.498 20.9807 18.498 24C18.498 27.0198 20.9783 29.5 23.998 29.5C27.0178 29.5 29.498 27.0198 29.498 24C29.498 20.9802 27.0178 18.5 23.998 18.5Z"
        fill="currentColor"
      />
    </>
  ),
  outline: (
    <>
      <path
        d="M26.999 24C26.999 22.3436 25.6555 21 23.999 21C22.3419 21 20.999 22.3433 20.999 24C20.999 25.6564 22.3426 27 23.999 27C25.6555 27 26.999 25.6564 26.999 24ZM30.999 24C30.999 27.8656 27.8646 31 23.999 31C20.1335 31 16.999 27.8656 16.999 24C16.999 20.1347 20.1322 17 23.999 17C27.8646 17 30.999 20.1344 30.999 24Z"
        fill="currentColor"
      />
      <path
        d="M10.999 24C10.999 22.3436 9.65545 21 7.99902 21C6.34185 21 4.99902 22.3433 4.99902 24C4.99902 25.6564 6.34259 27 7.99902 27C9.65545 27 10.999 25.6564 10.999 24ZM14.999 24C14.999 27.8656 11.8646 31 7.99902 31C4.13345 31 0.999023 27.8656 0.999023 24C0.999023 20.1347 4.13219 17 7.99902 17C11.8646 17 14.999 20.1344 14.999 24Z"
        fill="currentColor"
      />
      <path
        d="M42.999 24C42.999 22.3436 41.6555 21 39.999 21C38.3419 21 36.999 22.3433 36.999 24C36.999 25.6564 38.3426 27 39.999 27C41.6562 27 42.999 25.6567 42.999 24ZM46.999 24C46.999 27.8653 43.8659 31 39.999 31C36.1335 31 32.999 27.8656 32.999 24C32.999 20.1347 36.1322 17 39.999 17C43.8646 17 46.999 20.1344 46.999 24Z"
        fill="currentColor"
      />
    </>
  ),
});

export { MoreIcon };
export default MoreIcon;
